import { HomeOutlined, MailOutlined, PhoneOutlined } from "@ant-design/icons";
import { Divider, Empty, Flex, Space, Typography } from "antd";
import { useWhiteLabel } from "providers/whiteLabelProvider";
import styled from "styled-components";

const StyledDivider = styled(Divider)`
  background-color: #dbdbdb;
  @media (max-width: 768px) {
    transform: rotate(90deg);
  }
`;

const ContactInfoFlex = styled(Flex)`
  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

const { Link } = Typography;
function ConsumerPortalContactUs() {
  const { website, displayName, address, phone, email } = useWhiteLabel();
  return (
    // Hacking the AntD Empty component to make use of the stock image
    <Empty
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
      }}
      description={
        <Flex vertical justify="center" align="center">
          <h2 style={{ marginBottom: 0, marginTop: 0, fontWeight: "normal" }}>Need More Help?</h2>
          <p style={{ color: "gray", margin: 0 }}>
            If you have any questions or concerns, please contact your agency using the information
            below.
          </p>
          <br />

          <Flex vertical justify="center" align="center">
            <Link href={website} target="_blank" rel="noopener noreferrer">
              <Flex align="center">
                <h5
                  style={{ fontWeight: "normal", marginTop: 5, marginRight: 4, color: "#1890ff" }}
                >
                  {displayName}
                </h5>
              </Flex>
            </Link>
            <ContactInfoFlex align="center">
              <Space size="small">
                <HomeOutlined />
                <span>{address}</span>
              </Space>
              <StyledDivider type="vertical" />
              <Space size="small">
                <PhoneOutlined />
                <span>{phone}</span>
              </Space>
              <StyledDivider type="vertical" />
              <Space size="small">
                <MailOutlined />
                <span>{email}</span>
              </Space>
            </ContactInfoFlex>
          </Flex>
        </Flex>
      }
    />
  );
}

export default ConsumerPortalContactUs;
